import React from 'react';

import { withEventScope } from '@repo/event-processor';

import { FlexColumn } from 'styles/layouts';

import { Title, Wrapper, Subline } from './styles';
import { MicroAppWrapperProps } from './types';

const MicroAppWrapper: React.FC<
  MicroAppWrapperProps & { children?: React.ReactNode }
> = ({ title, subline, background, children }) => {
  return (
    <Wrapper background={background?.url}>
      <FlexColumn gap="20px">
        <Title>{title}</Title>
        <Subline>{subline}</Subline>
      </FlexColumn>
      {children}
    </Wrapper>
  );
};

export default withEventScope(MicroAppWrapper, { module: 'microAppWrapper' });
